export const DialogStyle = {
  zindex: 2500,
};
